import React from 'react'
import Screen from 'containers/Screen'
import PromocaoBox from 'components/PromocaoCGESP'

export default function PromocaoTJCGEScreen () {
  return (
    <Screen title={''}>
      <PromocaoBox />
    </Screen>
  )
}
